import { AppConstants, Loader, PluralPipe, PopoverComponent } from '@aston/foundation';
import { Component, computed, input } from '@angular/core';
import { NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';


import { DocumentFilesListComponent } from '../../../shared-module/components/document-files-list/document-files-list.component';
import { getFilesAllowedExtensions } from '../../../shared-module/functions';
import { DocumentCategory, DocumentType } from '../../../shared-module/enums';
import { DunningActionAttachment } from '../../classes';

@Component({
	selector: 'dunning-action-attachments-selection',
	styles: `
		.dunning-action-attachments-selection-panel {
			height: calc(30vh - 16px);
			overflow-y: scroll;
			overflow-x: hidden;
		}
	`,
	template: `
	<div class="d-flex flex-column">

		<h3>{{ 'Dunning.Completion.Attachments.SelectedItems' | plural:selectedAttachments().length | translate:{ count:selectedAttachments().length } }}</h3>
		<div class="dunning-action-attachments-selection-panel mb-5">
			<document-files-list
				[canDelete]="canDeleteAttachment()"
				[files]="selectedAttachments()"
				(removeDocument)="onDeleteAttachment($event)"
				(unselectDocument)="onUnselectAttachment($event)"
				(openDocument)="onOpenDocument($event)"
			/>
		</div>

		<h3 translate="Dunning.Completion.Attachments.SelectionTitle"></h3>
		<div>
			<input hidden
				type="file"
				[accept]="filesAllowedExtensions"
				(change)="onNewAttachment($any($event.target).files);fileInput.value = ''"
				#fileInput />

			<div class="d-flex align-items-center">
				<ul ngbNav #nav="ngbNav" class="nav-tabs align-items-center dunning-action-selection">
					<li ngbNavItem="Debtor">
						<a ngbNavLink translate="DocumentCategory.Debtor" data-cy="TabDebtor"></a>
						<ng-template ngbNavContent>
							<document-files-list
								[canDelete]="false"
								emptyText="Dunning.Completion.Attachments.NoneAvailable"
								[files]="documentsByCategory().Debtor"
								(selectDocument)="onSelectAttachment($event)"
								(openDocument)="onOpenDocument($event)"
							/>
						</ng-template>
					</li>
					<li ngbNavItem="Platform">
						<a ngbNavLink translate="DocumentCategory.Platform" data-cy="TabPlatform"></a>
						<ng-template ngbNavContent>
							<document-files-list
								[canDelete]="false"
								emptyText="Dunning.Completion.Attachments.NoneAvailable"
								[files]="documentsByCategory().Platform"
								(selectDocument)="onSelectAttachment($event)"
								(openDocument)="onOpenDocument($event)"
							/>
						</ng-template>
					</li>
					<li ngbNavItem="Accounting">
						<a ngbNavLink data-cy="TabAccounting">
							{{ 'DocumentCategory.AccountingAttachment' | translate }}
							@if (withAccountingSelectionHelp()) {
								<popover-component
									content="Dunning.Completion.Attachments.AccountingSelectionHelp"
									[translateValue]="true"
									triggers="hover focus"
									container="body"
								/>
							}
						</a>
						<ng-template ngbNavContent>
							<document-files-list
								[canSelect]="canSelectAccountingManagedFile"
								[canDelete]="false"
								emptyText="Dunning.Completion.Attachments.NoneAvailable"
								[files]="documentsByCategory().Accounting"
								(selectDocument)="onSelectAttachment($event)"
								(openDocument)="onOpenDocument($event)"
							/>
						</ng-template>
					</li>
				</ul>
				@if (canAddAttachment()) {
					<button class="btn btn-primary ml-auto"
						[disabled]="isDisabled()"
						(click)="fileInput.click()"
					><i class="far fa-plus-circle"></i> {{ 'Actions.AddDocument' | translate }}</button>
				}
			</div>
			<div class="dunning-action-attachments-selection-panel" [ngbNavOutlet]="nav"></div>
		</div>
	</div>
	`,
	imports: [TranslateModule, NgbNavModule, PluralPipe, DocumentFilesListComponent, PopoverComponent],
})
export class DunningActionAttachmentsSelectionComponent extends DunningActionAttachment {

	withAccountingSelectionHelp = input(false)
	canAddAttachment = input(false)
	canDeleteAttachment = input(false)
	loader = input(Loader.empty())
	isDisabled = input(false)

	DocumentCategory = DocumentCategory
	fileConfig = AppConstants.FILE_UPLOADER_CONFIGS.ATTACHMENT;
	filesAcceptedExtensions: string = this.fileConfig.acceptExtensions.join(AppConstants.LIST_ENUM_SEP_CHAR);
	filesAllowedExtensions = getFilesAllowedExtensions(this.fileConfig.acceptExtensions);
	canSelectAccountingManagedFile = f => [DocumentType.AccountingDocumentDocument, DocumentType.AccountingDocumentImage].includes(f.document?.documentType)

	selectedAttachments = computed(() => this.attachments().filter(attachment => attachment.selected))
	documentsByCategory = computed(() => ({
		[DocumentCategory.Accounting]: this.attachments().filter(a => !a.selected && [DocumentCategory.Accounting, DocumentCategory.AccountingAttachment].includes(a.document.category as DocumentCategory)),
		[DocumentCategory.Platform]: this.attachments().filter(a => !a.selected && a.document.category === DocumentCategory.Platform),
		[DocumentCategory.Debtor]: this.attachments().filter(a => !a.selected && a.document.category === DocumentCategory.Debtor),
	}))
}
